
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uiboarddetails",
      function () {
        return require("private-next-pages/uiboarddetails/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uiboarddetails"])
      });
    }
  